import { Box, Flex, Heading, Text } from '@weareberyl/design-system'
import { Button, Timeline } from 'antd'
import { useState } from 'react'
import {
  useJourneyPreviewFragment,
  useSendCustomNotificationMutation,
  type SendCustomNotificationMutationVariables,
} from '~/gql/generated/graphql'

const options = [
  {
    key: 'photo_problem',
    title: 'Photo problem',
    label: 'Photo problem',
    body: 'This photo is blurry, please try again',
  },
  {
    key: 'invalid_parking_upright',
    label: 'Invalid parking (upright)',
    title: 'Invalid parking',
    body: 'Please park the vehicle, upright inside a bay',
  },
  {
    key: 'invalid_parking',
    label: 'Invalid parking',
    title: 'Invalid parking',
    body: 'Please park the vehicle, inside a bay',
  },
] as const

type ParkingOption = (typeof options)[number]
type LogItem = Omit<SendCustomNotificationMutationVariables, 'userId'> & {
  timestamp: Date
}

function ParkingSuggestions({ journeyId }: { journeyId: string }) {
  const [log, addLog] = useState<LogItem[]>([])
  const [sendNotification, { loading }] = useSendCustomNotificationMutation()
  const { data } = useJourneyPreviewFragment({ id: journeyId })

  const userId = data?.user?.id
  if (!userId) {
    return null
  }

  const onClick = async (option: ParkingOption) => {
    const { key, label, ...values } = option

    await sendNotification({
      variables: {
        userId,
        ...values,
      },
    })
    addLog(rows => [...rows, { ...values, timestamp: new Date() }])
  }

  return (
    <Box my={3} mx={3}>
      <Heading>Parking suggestions</Heading>
      <Box style={{ gap: 10 }} my={3}>
        {options.map(option => (
          <Button
            type="ghost"
            key={option.key}
            title={option.title}
            onClick={() => onClick(option)}
            loading={loading}
          >
            Send: {option.label}
          </Button>
        ))}
      </Box>
      <Box mt={2}>
        <Timeline mode="left">
          {log.toReversed().map(item => (
            <Timeline.Item label={item.timestamp.toLocaleTimeString()}>
              <Box>
                <Heading variant="h5">{item.title}</Heading>
                <Text>{item.body}</Text>
              </Box>
            </Timeline.Item>
          ))}
        </Timeline>
      </Box>
    </Box>
  )
}

export default ParkingSuggestions
